export const MODELS_PAGE_LINK_TEST_ID = "models-page-link";
export const ASSET_UPLOAD_INPUT_TEST_ID = "asset-upload-input";
export const ADD_ASSET_BUTTON_TEST_ID = "add-asset-button";
export const ADD_ASSET_INPUT_TEST_ID = "add-asset-input";
export const ASSETS_GRID_TEST_ID = "assets-grid";
export const SELECTABLE_CHECKBOX_TEST_ID = "selectable-checkbox";
export const DELETE_SELECTED_BUTTON_TEST_ID = "delete-seleceted-button";
export const ADD_GROUP_BUTTON_TEST_ID = "add-group-button";
export const DELETE_GROUP_BUTTON_TEST_ID = "delete-group-button";
export const GROUPS_LIST_TEST_ID = "groups-list";
export const ADD_OPTION_BUTTON_TEST_ID = (type: "color" | "material") => `add-${type}-option-button`;
export const DELETE_OPTION_BUTTON_TEST_ID = (type: "color" | "material") => `delete-${type}-option-button`;
export const NODES_LIST_TEST_ID = "nodes-list";
export const OPTIONS_LIST_TEST_ID = (type: "color" | "material") => `${type}-options-list`;
export const UPLOAD_FILE_BUTTON_TEST_ID = "upload-file-button";
export const TAKE_PHOTO_BUTTON_TEST_ID = "take-photo-button";
export const ASSET_CARD_TEST_ID = "asset-card";
export const CONFIGURATOR_CARD_TEST_ID = "configurator-card-test-id";
export const NODE_NAME_INPUT_TEST_ID = "node-name-input";
export const ADD_MEMBER_BUTTON_TEST_ID = "add-memeber-button";
export const GROUP_MEMBERS_LIST_TEST_ID = "group-members";
export const REMOVE_MEMBER_BUTTON_TEST_ID = "remove-member-button";
export const OPTION_VALUE_INPUT_TEST_ID = "option-value-input";
export const OPTION_ID_INPUT_TEST_ID = "option-id-input";
export const OPTION_LABEL_INPUT_TEST_ID = "option-label-input";
export const OPTION_PRICE_INPUT_TEST_ID = "option-price-input";
export const CONFIGURATOR_SAVE_BUTTON_TEST_ID = "configurator-save-button";
export const CONFIGURATOR_BACK_BUTTON_TEST_ID = "configurator-back-button";
export const CONFIGURATOR_PREVIEW_BUTTON_TEST_ID = "configurator-preview-button";
export const CUSTOMIZER_SAVE_BUTTON_TEST_ID = "customizer-save-button";
export const MODEL_DATA_TEST_ID = "configurio-model-data";
export const OPTION_BUTTON_TEST_ID = (id: string) => `option-button-${id}`;
